import { Box } from '@mui/material';

const Bullet = ({
  color,
  marginLeft,
}: {
  color: string;
  marginLeft?: string;
}) => {
  return (
    <Box
      sx={{
        minWidth: '10px',
        maxWidth: '10px',
        minHeight: '10px',
        maxHeight: '10px',
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '8px',
        background: color,
        marginLeft,
      }}
    />
  );
};

export default Bullet;
export { Bullet };
